import DOMPurify from 'dompurify';

const setSanitizedHtml = (el, value) => {
  el.innerHTML = DOMPurify.sanitize(value == null ? '' : String(value));
};

export const safeHtml = {
  bind(el, binding) {
    setSanitizedHtml(el, binding.value);
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      setSanitizedHtml(el, binding.value);
    }
  },
  unbind(el) {
    el.innerHTML = '';
  },
};
